import { IApiGeoGeocodedForSearchRequest } from '../../repositories/monolith-cian-realty/unversioned/api-geo-geocoded-for-search';
import { IGeoCodedForSearch, IRegion } from '../../types/geo';
import { getGeocodedSearchData } from '../../api/get_geocoded_search_data';
import { IThunkActionCreator } from '../../types/store';
import { createRegionSeoUrl } from '../../utils/seo';
import { changePage } from '../filters/actions';
import { geocodedForSearchError, geocodedForSearchFetched } from './actions';

export function fetchGeocodedSearchData(parameters: IApiGeoGeocodedForSearchRequest): IThunkActionCreator {
  return async (dispatch, getState, context) => {
    try {
      const response = await getGeocodedSearchData(context.httpApi, parameters, context.logger, context.subdomain);

      dispatch(geocodedForSearchFetched(response as IGeoCodedForSearch));
      if (response.text) {
        const { geo, filters } = getState();

        dispatch(changePage(1, true));
        window.location.href = await createRegionSeoUrl(
          context,
          (geo.regions as IRegion[]) || [],
          filters,
          filters.regionId,
        );
      }
    } catch (error) {
      dispatch(geocodedForSearchError(error.message));
    }
  };
}
